import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconSpeedtuneup = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={21}
    fill="none"
    viewBox="0 0 20 21"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-speed_tuneup_svg__a)"
      d="m17.07 11.477-9.96 8.71a1.301 1.301 0 0 1-.86.313c-.273 0-.547-.078-.742-.234a1.214 1.214 0 0 1-.43-1.485l3.008-7.031H3.75c-.547 0-1.016-.313-1.172-.781-.195-.508-.078-1.055.313-1.406l10-8.711c.43-.391 1.054-.391 1.523-.04.508.313.664.938.43 1.485l-3.008 6.992h4.375c.508 0 .977.352 1.172.82a1.21 1.21 0 0 1-.313 1.368Z"
    />
    <defs>
      <linearGradient
        id="icon-speed_tuneup_svg__a"
        x1={20}
        x2={1.025}
        y1={1}
        y2={20.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCF4BF" />
        <stop offset={0.18} stopColor="#EFC862" />
        <stop offset={0.73} stopColor="#CD9832" />
        <stop offset={1} stopColor="#BB811B" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconSpeedtuneup;
